import { getWfgIRName } from '../../../utils/orderTask';
import { recordException } from '../../../utils/reporting';

export const nameMap = {
  '1800_accountant': () => '1-800Accountant',
  adjustment: () => 'Adjustment',
  annual_report_service: () => 'Annual Report Service',
  bank_of_america_offer: () => 'Bank of America Offer',
  banking: () => 'Banking',
  banking_resolution: () => 'Banking Resolution Template',
  basic_email: () => 'Business Email',
  business_kit: (_orderTask, businessEntityType) => `${businessEntityType === 'llc' ? 'LLC' : 'Corporate'} Business Kit`,
  business_license_report: () => 'Business License Report',
  change_of_registered_agent: ({ orderTaskData: { jurisdiction }, orderTaskJurisdiction }) => `Change of Registered Agent (${jurisdiction || orderTaskJurisdiction})`,
  corp_amendment: () => 'Corporate Amendment',
  corp_annual_report: ({ orderTaskData: { jurisdiction } }) => `Annual Report (${jurisdiction})`,
  corp_formation: () => 'Corp Formation',
  corporate_docs: () => 'Business Document Templates Library',
  credit_card_offer: () => 'Credit Card Offer',
  dao_designation: () => 'DAO Formation',
  dba_compliance: () => 'Ongoing DBA Name Compliance',
  dba_entity: () => 'DBA Name Registration',
  dissolution: () => 'Dissolution',
  domain_name_privacy: () => 'Domain Name Privacy',
  domain_name_reg: () => 'Domain Name',
  ein_business_docs_bundle: () => 'EIN & Business Documents Bundle',
  ein_creation: () => 'Employer ID Number (EIN)',
  entity_name_reservation: () => 'Entity Name Reservation',
  expedite: () => 'Expedite Filing Speed',
  expedite_to_rush_upgrade: () => 'Expedite to Rush Upgrade',
  extra_credits: () => 'Extra Credits',
  future_file_date: () => 'Future Filing Date',
  initial_cpa_screening: () => 'Free Accounting Consultation',
  llc_amendment: () => 'LLC Amendment',
  llc_annual_report: ({ orderTaskData: { jurisdiction } }) => `Annual Report (${jurisdiction})`,
  llc_formation: () => 'State Filing Fee',
  ny_publication: ({ orderTaskData: { jurisdiction } }) => jurisdiction && `${jurisdiction} Publication`,
  operating_agreement: () => 'Operating Agreement',
  personal_credit_monitoring: () => 'Credit Monitoring',
  priority: () => 'Expedite Filing Speed',
  protection_services: () => 'Additional Services',
  registered_agent_service: ({ orderTaskData: { isCora, jurisdiction } }) => (
    `Registered Agent ${isCora ? `(${jurisdiction})` : 'Service'}`
  ),
  reinstatement: () => 'Reinstatement',
  resignation: () => 'Resignation',
  rush: () => 'Rush Filing Speed',
  s_corp_conversion: () => 'S-Corp Conversion',
  s_corp_designation: () => 'S-Corp Designation',
  standard_good_standing: () => 'Certificate of Good Standing',
  static_website: () => 'Business Website',
  tax_filing: () => 'Tax Filing',
  tax_preparation: () => 'Business Tax Prep and Filing',
  unknown: () => 'Additional Services',
  virtual_business_address: () => 'Virtual Mailing Address',
  website_tools_bundle: () => 'Website Tools Bundle',
  wfg_initial_report: ({ jurisdiction }) => `${getWfgIRName(jurisdiction)} Service`,
  worry_free_service: () => 'Worry-Free Compliance',
  zb_money_essential: () => 'ZB Money Essential',
  zb_money_pro: () => 'Money Pro'
};

const filterTasks = ['free_year_package', 'standard', 'the_starter_package'];

const planNameMap = {
  starter_plan: 'Starter Plan',
  pro_plan: 'Pro Plan',
  premium_plan: 'Premium Plan',
  subscription_plan: 'Monthly Subscription'
};

function mapPlanName(str) {
  return planNameMap[str];
}

export const getDisplayName = (task, businessEntityType) => {
  const { orderTaskType: type, displayName = '' } = task;

  // handle plan names
  const plan = type.match(/(starter_plan|pro_plan|premium_plan|subscription_plan)/);
  if (plan) {
    return mapPlanName(plan[0]);
  }

  if (nameMap[type]) {
    return nameMap[type](task, businessEntityType);
  }

  // if not a plan or if display name is falsy, send an error
  if (!(displayName || filterTasks.includes(type))) {
    recordException(new Error(`Order task ${type} missing from order support`));
  }

  return displayName;
};
